import { Injectable } from '@angular/core';

// import typings
import { createRxDatabase } from 'rxdb';
import { environment } from 'src/environments/environment';
import { CLU_DOCCURRENTPIECE_SCHEMA } from '../@schemas/clu_doccurrentpiece.schema';
import { CLU_DOCENTETE_SCHEMA } from '../@schemas/clu_docentete.schema';
import { CLU_DOCLIGNE_SCHEMA } from '../@schemas/clu_docligne.schema';
import { CLU_DOCREGLEMENT_SCHEMA } from '../@schemas/clu_docreglement.schema';
import { RxRemDocsCollections, RxRemDocsDatabase } from './m-remdocs-core-rxdb';
import { F_ARTICLE_SCHEMA } from '../@schemas/f_article.schema';
import { F_COMPTET_SCHEMA } from '../@schemas/f_comptet.schema';
import { P_PARAMS_SCHEMA } from '../@schemas/p_params.schema';
import { F_DEPOT_SCHEMA } from '../@schemas/f_depot.schema';
import { F_COLLABORATEUR_SCHEMA } from '../@schemas/f_collaborateur.schema';
import { F_ARTGAMME_SCHEMA } from '../@schemas/f_artgamme.schema';
import { F_ARTENUMREF_SCHEMA } from '../@schemas/f_artenumref.schema';
import { F_TARIFGAM_SCHEMA } from '../@schemas/f_tarifgam.schema';
import { F_TARIFQTE_SCHEMA } from '../@schemas/f_tarifqte.schema';
import { F_TARIFCOND_SCHEMA } from '../@schemas/f_tarifcond.schema';
import { F_ARTCLIENT_SCHEMA } from '../@schemas/f_artclient.schema';
import { F_ARTCOMPTA_SCHEMA } from '../@schemas/f_artcompta.schema';
import { F_FAMCOMPTA_SCHEMA } from '../@schemas/f_famcompta.schema';
import { F_NOMENCLAT_SCHEMA } from '../@schemas/f_nomenclat.schema';
import { F_CLIENT_SCHEMA } from '../@schemas/f_client.schema';
import { F_FOURNISSEUR_SCHEMA } from '../@schemas/f_fournisseur.schema';
import { F_COMPTEA_SCHEMA } from '../@schemas/f_comptea.schema';
import { P_DEVISE_SCHEMA } from '../@schemas/p_devise.schema';
import { P_REGLEMENT_SCHEMA } from '../@schemas/p_reglement.schema';
import { F_CONDITION_SCHEMA } from '../@schemas/f_condition.schema';
import { P_DOSSIER_SCHEMA } from '../@schemas/p_dossier.schema';
import { F_MODELE_SCHEMA } from '../@schemas/f_modele.schema';
import { F_ARTMODELE_SCHEMA } from '../@schemas/f_artmodele.schema';
import { P_SOUCHEVENTE_SCHEMA } from '../@schemas/p_souchevente.schema';
import { P_SOUCHEACHAT_SCHEMA } from '../@schemas/p_soucheachat.schema';
import { P_SOUCHEINTERNE_SCHEMA } from '../@schemas/p_soucheinterne.schema';
import { F_TAXE_SCHEMA } from '../@schemas/f_taxe.schema';
import { CBSYSLIBRE_SCHEMA } from '../@schemas/cbsyslibre.schema';
import { CLU_DOCECHEANCE_SCHEMA } from '../@schemas/clu_docecheance.schema';
import { F_ARTFOURNISS_SCHEMA } from '../@schemas/f_artfourniss.schema';
import { F_JOURNAUX_SCHEMA } from '../@schemas/f_journaux.schema';
import { P_MODELE_IMPRESSION_REMDOCS_SCHEMA } from '../@schemas/p_modele_impression.schema';
import { F_TARIF_SCHEMA } from '../@schemas/f_tarif.schema';
import { F_TARIFSELECT_SCHEMA } from '../@schemas/f_tarifselect.schema';
import { F_FAMILLE_SCHEMA } from '../@schemas/f_famille.schema';
import { P_INTERNE_SCHEMA } from '../@schemas/p_interne.schema';
import { F_FAMCLIENT_SCHEMA } from '../@schemas/f_famclient.schema';
import { F_FAMTARIFQTE_SCHEMA } from '../@schemas/f_famtarifqte.schema';
import { F_FAMTARIF_SCHEMA } from '../@schemas/f_famtarif.schema';

const collectionSettings = {
    ['cludoccurrentpiece']: {
        schema: CLU_DOCCURRENTPIECE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { }
    },
    ['cludocentete']: {
        schema: CLU_DOCENTETE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1 : (oldDoc : any) => { oldDoc.N_ANALYTIQUE = 0; return oldDoc; },
            2 : (oldDoc : any) => { oldDoc.DO_TYPEFRAIS = 0; oldDoc.DO_VALFRAIS = 0; oldDoc.DO_TYPEFRANCO = 0; oldDoc.DO_TYPELIGNEFRAIS = 0; oldDoc.DO_TXESCOMPTE = 0; oldDoc.DO_ESCOMPTE = 0; oldDoc.DO_VALIDE = 0; return oldDoc; },
            3 : (oldDoc : any) => { oldDoc.DO_CODETAXE1 = 0; oldDoc.DO_TYPETAUX1 = 0; oldDoc.DO_TYPETAXE1 = 0; oldDoc.DO_TAXE1 = 0;
                                    oldDoc.DO_CODETAXE2 = 0; oldDoc.DO_TYPETAUX2 = 0; oldDoc.DO_TYPETAXE2 = 0; oldDoc.DO_TAXE2 = 0;
                                    oldDoc.DO_CODETAXE3 = 0; oldDoc.DO_TYPETAUX3 = 0; oldDoc.DO_TYPETAXE3 = 0; oldDoc.DO_TAXE3 = 0;
                                    oldDoc.DO_EXPEDIT = 0; oldDoc.DO_EXPEDITLIB = ''; oldDoc.DO_EXPEDIT_ARREF = ''; oldDoc.DO_CONDITION = 0; oldDoc.DO_CONDITIONLIB = ''; return oldDoc; },
            4 : (oldDoc : any) => { oldDoc.DE_INTITULE_ORIG = ''; oldDoc.DE_INTITULE_DEST = ''; oldDoc.DO_TYPEI = 0; oldDoc.DO_TYPEI_LIB = ''; oldDoc.DO_TYPEI_INTITULE = ''; oldDoc.DO_DATELIVR = ''; oldDoc.DO_CONTACT = '';
                                    oldDoc.DO_LANGUE = 0; oldDoc.DO_LANGUE_LIB = ''; oldDoc.LI_NO = 0; oldDoc.LI_LIB = ''; oldDoc.CT_NUMPAYEUR = ''; oldDoc.CT_NUMCENTRALE = ''; oldDoc.DO_TARIF = 0; oldDoc.DO_TARIF_LIB = ''; return oldDoc; },
            5 : (oldDoc : any) => { oldDoc.CT_CBCREATION = ''; oldDoc.CT_TELEPHONE = ''; oldDoc.CT_TELECOPIE = ''; oldDoc.CT_EMAIL = ''; oldDoc.CT_SITE = ''; oldDoc.CT_FACEBOOK = ''; oldDoc.CT_LINKEDIN = '';
            oldDoc.CT_SIRET = ''; oldDoc.CT_IDENTIFIANT = ''; oldDoc.BT_INTITULE = ''; oldDoc.CT_ADRESSE = ''; oldDoc.CT_COMPLEMENT = ''; oldDoc.CT_CODEPOSTAL = ''; oldDoc.CT_CODEREGION = ''; oldDoc.CT_VILLE = ''; oldDoc.CT_PAYS = ''; return oldDoc; },
            6: (oldDoc : any) => {
                oldDoc.CO_NOM = ''; oldDoc.CO_PRENOM = ''; oldDoc.CO_FONCTION = ''; oldDoc.CO_ADRESSE = ''; oldDoc.CO_COMPLEMENT = ''; oldDoc.CO_CODEPOSTAL = ''; oldDoc.CO_VILLE = ''; oldDoc.CO_PAYS = ''; oldDoc.CO_SERVICE = '';
                oldDoc.CO_TELEPHONE = ''; oldDoc.CO_EMAIL = ''; return oldDoc;
            }
        }
    },
    ['cludocligne']: {
        schema: CLU_DOCLIGNE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { 1 : (oldDoc : any) => { oldDoc.DL_ESCOMPTE = 0; return oldDoc; },
                               2 : (oldDoc : any) => { oldDoc.DL_PIECEDE = ''; oldDoc.DL_PIECEBC = ''; oldDoc.DL_PIECEPL = ''; oldDoc.DL_PIECEBL = ''; oldDoc.DL_DATEDE = ''; oldDoc.DL_DATEBC = ''; oldDoc.DL_DATEPL = ''; oldDoc.DL_DATEBL = ''; return oldDoc; },
                               3 : (oldDoc : any) => { oldDoc.DL_QTEDE = 0; oldDoc.DL_QTEBC = 0; oldDoc.DL_QTEPL = 0; oldDoc.DL_QTEBL = 0; return oldDoc; },
                               4 : (oldDoc : any) => { oldDoc.DL_PRIXRU = 0; oldDoc.DL_CMUP = 0; return oldDoc; },
                               5 : (oldDoc : any) => { oldDoc.CA_INTITULE = ''; return oldDoc; } }
    },
    ['cludocreglement']: {
        schema: CLU_DOCREGLEMENT_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1 : (oldDoc : any) => { oldDoc.RG_PIECE = ''; oldDoc.JO_NUM = ''; oldDoc.RG_LIBELLE = ''; oldDoc.RG_TYPEREG = 0; return oldDoc; },
            2 : (oldDoc : any) => { oldDoc.DO_PIECEACOMPTE = ''; return oldDoc; }
        }
    },
    ['cludocecheance']: {
        schema: CLU_DOCECHEANCE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { }
    },
    ['farticle']: {
        schema: F_ARTICLE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1 : (oldDoc : any) => { oldDoc.AR_PRIXACH = 0; return oldDoc; },
            2 : (oldDoc : any) => { oldDoc.AR_POIDSBRUT = 0; oldDoc.AR_POIDSNET = 0; return oldDoc; },
            3 : (oldDoc : any) => { return oldDoc; },
            4 : (oldDoc : any) => { return oldDoc; },
        }
    },
    ['ffamille']: {
        schema: F_FAMILLE_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { }
    },
    ['fcomptet']: {
        schema: F_COMPTET_SCHEMA, methods: { }, sync: false,
        migrationStrategies: { }
    },
    ['pparams'] : {
        schema : P_PARAMS_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['pinterne'] : {
        schema : P_INTERNE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.D_MVTSTOCK = 0; return oldDoc; }
        }
    },
    ['fdepot'] : {
        schema : F_DEPOT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fcollaborateur'] : {
        schema : F_COLLABORATEUR_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.CO_DOMAINE = 0; return oldDoc; }
        }
    },
    ['fartgamme'] : {
        schema : F_ARTGAMME_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fartenumref'] : {
        schema : F_ARTENUMREF_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ftarifgam'] : {
        schema : F_TARIFGAM_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ftarifqte'] : {
        schema : F_TARIFQTE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ftarifcond'] : {
        schema : F_TARIFCOND_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fartclient'] : {
        schema : F_ARTCLIENT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ffamclient'] : {
        schema : F_FAMCLIENT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ffamtarif'] : {
        schema : F_FAMTARIF_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ffamtarifqte'] : {
        schema : F_FAMTARIFQTE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fartfourniss'] : {
        schema : F_ARTFOURNISS_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fartcompta'] : {
        schema : F_ARTCOMPTA_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.ACP_TYPE = 0; return oldDoc; }
        }
    },
    ['ffamcompta'] : {
        schema : F_FAMCOMPTA_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.FCP_TYPE = 0; return oldDoc; }
        }
    },
    ['fnomenclature'] : {
        schema : F_NOMENCLAT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fclient'] : {
        schema : F_CLIENT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ffournisseur'] : {
        schema : F_FOURNISSEUR_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fcomptea'] : {
        schema : F_COMPTEA_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['pdevise'] : {
        schema : P_DEVISE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['preglement'] : {
        schema : P_REGLEMENT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.SCD_TYPE = 0; oldDoc.JO_NUMCLI = ''; oldDoc.JO_NUMFOUR = ''; return oldDoc; }
        }
    },
    ['fcondition'] : {
        schema : F_CONDITION_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['pdossier'] : {
        schema : P_DOSSIER_SCHEMA, methods : { }, sync: false,
        migrationStrategies : {
            1 : (oldDoc : any) => { oldDoc.D_RCS = ''; return oldDoc; },
            2 : (oldDoc : any) => { oldDoc.D_SIRET = ''; oldDoc.D_APE = ''; oldDoc.D_IDENTIFIANT = ''; return oldDoc; },
        }
    },
    ['pmodeleimpression_remdocs']: {
        schema: P_MODELE_IMPRESSION_REMDOCS_SCHEMA, methods: { }, sync: false,
        migrationStrategies: {
            1 : (oldDoc : any) => { oldDoc.TYPE_IMPRESSION = 1; return oldDoc; },
        }
    },
    ['cbsyslibre'] : {
        schema : CBSYSLIBRE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fmodele'] : {
        schema : F_MODELE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fartmodele'] : {
        schema : F_ARTMODELE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['psouchevente'] : {
        schema : P_SOUCHEVENTE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['psoucheachat'] : {
        schema : P_SOUCHEACHAT_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['psoucheinterne'] : {
        schema : P_SOUCHEINTERNE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['ftarif']: {
        schema: F_TARIF_SCHEMA, methods: { }, sync: false,
        migrationStrategies : { }
    },
    ['ftarifselect']: {
        schema: F_TARIFSELECT_SCHEMA, methods: { }, sync: false,
        migrationStrategies : { }
    },
    ['ftaxe'] : {
        schema : F_TAXE_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
    ['fjournaux'] : {
        schema : F_JOURNAUX_SCHEMA, methods : { }, sync: false,
        migrationStrategies : { }
    },
};

/**
 * creates the database
 */
async function _create(): Promise<RxRemDocsDatabase> {
    //removeRxDatabase('dblinkupremdocs', environment.getRxStorage());
    environment.addRxDBPlugins();
    console.log('RemDocsCoreRxDbService: creating database..');
    const db = await createRxDatabase<RxRemDocsCollections>({
        name: 'dblinkupremdocs',
        storage: environment.getRxStorage(),
        multiInstance: environment.multiInstance,
        // password: 'myLongAndStupidPassword' // no password needed
    });
    console.log('RemDocsCoreRxDbService: created database');

    if (!environment.isServerSideRendering) {
        // write to window for debugging
        (window as any)['db'] = db;
    }

    // show leadership in title
    if (environment.multiInstance) {
        db.waitForLeadership()
            .then(() => {
                console.log('isLeader now');
                document.title = document.title.includes('♛') ? document.title : '♛ ' + document.title;
            });
    }

    // create collections
    console.log('RemDocsCoreRxDbService: create collections');
    await db.addCollections(collectionSettings);


    // hooks
    /*console.log('RemDocsCoreRxDbService: add hooks');
    console.log(db.collections);
    db.collections.farticle.preInsert(function (docObj: RxFArticleDocumentType) {
        const AR_REF = docObj.AR_REF;
        return db.collections.farticle
            .findOne({ selector: { AR_REF } })
            .exec()
            .then((has: RxFArticleDocument | null) => {
                if (has != null) {
                    alert('another article already has the AR_REF ' + AR_REF);
                    throw new Error('AR_REF already there');
                }
                return db;
            });
    }, false);*/

    console.log('RemDocsCoreRxDbService: created');

    return db;
}


let initState: null | Promise<any> = null;;
let DB_INSTANCE: RxRemDocsDatabase;

/**
 * This is run via APP_INITIALIZER in app.module.ts
 * to ensure the database exists before the angular-app starts up
 */
export async function initDatabase_RemDocsRxDb() {
    /**
     * When server side rendering is used,
     * The database might already be there
     */
    if (!initState) {
        console.log('initDatabase_RemDocsRxDb()');
        initState = _create().then(db => DB_INSTANCE = db);
    }
    await initState;
}

@Injectable()
export class RemDocsCoreRxDbService {
    get db(): RxRemDocsDatabase {
        return DB_INSTANCE;
    }
}
